const createDSDefaultState = {
    pdfDocument: null,
    imageForSign: null,
    commonName: "",
    macPassword: "",
    signaturePageNumber: 1,
    signaturePositionX: 20,
    signaturePositionY: 20,
    signedDataForInputFile: null,
    convertedImage: null,
    signatureImageWidth: 50,
    signatureImageHeight: 50,
    showedOnce: true,
    imageParamsSetted: false
}

const createDSReducer = (state = createDSDefaultState, { type, payload }) => {

    switch (type) {

        case "SET_PDF_DOCUMENT":
            return {
                ...state,
                pdfDocument: payload
            }

        case "SET_IMAGE_FOR_SIGN":
            return {
                ...state,
                imageForSign: payload
            }

        case "SET_COMMON_NAME":
            return {
                ...state,
                commonName: payload
            }

        case "SET_MAC_PASSWORD":
            return {
                ...state,
                macPassword: payload
            }

        case "SET_SIGNATURE_PAGE_NUMBER":
            return {
                ...state,
                signaturePageNumber: payload
            }

        case "SET_SIGNATURE_POSITION_X":
            return {
                ...state,
                signaturePositionX: payload
            }

        case "SET_SIGNATURE_POSITION_Y":
            return {
                ...state,
                signaturePositionY: payload
            }

        case "SET_SIGNED_DATA_FOR_INPUT_FILE":
            return {
                ...state,
                signedDataForInputFile: payload
            }

        case "SET_CONVERTED_IMAGE":
            return {
                ...state,
                convertedImage: payload
            }

        case "SET_SIGNATURE_SIZE":
            return {
                ...state,
                signatureImageWidth: Math.round(payload.width),
                signatureImageHeight: Math.round(payload.height)
            }

        case "SET_SHOWED_ONCE":
            return {
                ...state,
                showedOnce: payload
            }

        case "SET_IMAGE_PARAMS_SETTED":
            return {
                ...state,
                imageParamsSetted: payload
            }

        default:
            return state;
    }

}

export default createDSReducer